.ManageSessionsPage {
	--content-space-top: 5vh;
}
.ManageSessionsPage__sessions {
	max-width: 535px;
	flex: 1;
}
.ManageSessionsPage__goBack {
	margin-bottom: 5px;
}
.ManageSessionsPage__title {
	font: var(--title-large);
	margin-bottom: 60px;
}
